import { combineReducers } from 'redux';
import documentReducer from '../features/editor/dashEditorSlice';
import libraryReducer from '../features/library/librarySlice';
import authReducer from '../features/auth/authSlice';
import preferencesReducer from '../features/editor/header/preferencesSlice';
import ideReducer from '../features/ide/ideSlice';
import backgroundTasksReducer from '../features/ide/backgroundTasksSlice';
import agentsReducer from '../features/agents/agentsSlice';
import navigationReducer from '../features/navigation/navigationSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    library: libraryReducer,
    document: documentReducer,
    preferences: preferencesReducer,
    ide: ideReducer,
    backgroundTasks: backgroundTasksReducer,
    agents: agentsReducer,
    navigation: navigationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;